import React from 'react';
import { ForecastCardTitleHourDay } from '../styles';
import { IForecastCard } from './types';

type ForecastCardTitleDayProps = Pick<IForecastCard, 'day'>;

export const ForecastCardTitleDay = ({ day }: ForecastCardTitleDayProps) => {
    return (
        <ForecastCardTitleHourDay isDayTitleText={true} >
            {day}
        </ForecastCardTitleHourDay>
    );
};